export enum TypeModal {
  confirm,
  notification,
  warning
}
